import styled from 'styled-components';
import theme from 'theme/theme';
import media from 'utils/MediaQueries';

const Wrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-top: 100px;
	padding: 0 10px;

	${media.phone`
		margin-top: 50px;
	`};
`;

const Title = styled.h1`
	font-size: 30px;
	color: ${theme.text2};
	margin-top: 10px;

	${media.phone`
		font-size: 20px;
	`};
`;

const Image = styled.img`
	width: 100%;
	max-width: 400px;

	${media.phone`
		width: 50%;
	`};
`;

const Text = styled.p`
	width: 100%;
	max-width: 400px;
	margin: 0;
	color: ${theme.text2};
	text-align: center;
	font-weight: 800;

	${media.phone`
		width: 50%;
		font-size: 12px;
	`};
`;

export { Wrapper, Title, Image, Text };
